
import * as noneRuntime$_4fUHq0KaXSfTTtgLYlvteBPAUcjd0_45rjvCcHLVNk4Pw from '/home/runner/work/dartsspace/dartsspace/node_modules/.pnpm/@nuxt+image@1.10.0_@capacitor+preferences@7.0.1_@capacitor+core@7.2.0__@netlify+blobs@8.2.0_d_p65dazci75shawans7a2hydklm/node_modules/@nuxt/image/dist/runtime/providers/none'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "none",
  "domains": [
    "dartsspace.com",
    "dartsspace.test"
  ],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['none']: { provider: noneRuntime$_4fUHq0KaXSfTTtgLYlvteBPAUcjd0_45rjvCcHLVNk4Pw, defaults: {} }
}
        